<p-confirmDialog #cd key="{{pDialogKey}}"
	header="{{'fs.res.common.confirmation.delete'|hisUi}}">
    <ng-template #footer>
       		<button (click)="cd.onAccept()"><span>{{'de.his.javang.ja'|hisUi}}</span></button>	
			<button (click)="cd.onReject()"><span>{{'de.his.javang.nein'|hisUi}}</span></button>
     </ng-template>
</p-confirmDialog>